import './App.css';
import './reset.css';
import { Routes, Route, Outlet } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import MenuSidebar from './Components/Sidebar';
import LoginImages from './Components/LoginImages';
import { OrganizationApiProvider } from './Services/OrganizationApiProvider';
import { useRef } from 'react';
import './Components/KnowledgeChatLauncher.css';
import KnowledgeChat from './Components/KnowledgeChat';
import { ChatAnalyticsApiProvider } from './Services/ChatAnalyticsApiProvider';
import { useAuth } from './Contexts/AuthContext';

function App() {
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleChat = () => {
    setIsOpen((prev) => !prev);
  };
  const [permissions, setPermissions] = useState([]);

  const { status } = useAuth();
  useEffect(() => {
    setPermissions(status.permissions || []);
  }, [status]);

  return (
    <div className="app-container">
      <OrganizationApiProvider>
        <ChatAnalyticsApiProvider>
          <MenuSidebar />
          <div className="content-container" ref={containerRef}>
            <Header />
            <main className="main-content">
              <Outlet context={{ containerRef }} />
            </main>
            {/* Knowledge Chat Floating Button */}
            {permissions.includes('organization:admin_chat') && (
              <div className="chat-launcher" onClick={toggleChat}></div>
            )}
            {/* Knowledge Chat Panel (toggle visibility) */}
            {isOpen && (
              <div className="chat-overlay">
                <div className="chat-wrapper">
                  <KnowledgeChat />
                </div>
              </div>
            )}

            <Footer />
            <LoginImages />
          </div>
        </ChatAnalyticsApiProvider>
      </OrganizationApiProvider>
    </div>
  );
}

export default App;
